import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WorkoutPrintService } from 'src/app/services/workout-print.service';

@Component({
  selector: 'me-print-workout-page',
  template: '',
})
export class PrintWorkoutPage implements OnInit {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly $workoutPrint: WorkoutPrintService
  ) {}

  async ngOnInit() {
    const printId = this.route.snapshot.queryParamMap.get('printId');

    if (!printId) {
      return;
    }

    await this.$workoutPrint.printStoredWorkout({ printId });
  }
}
